export default __webpack_public_path__ + "static/media/linux.bf3720c7.svg";